<template>
    <div>
        <label><input type="checkbox" v-model="block.showInNavigation" ref="showInNavigation"> In Navigation
            anzeigen</label>
        <text-input :value="block.name" label="Name" ref="name"></text-input>
        <text-input :value="block.link" label="Link" ref="link"/>
        <div class="admin-info">
            Bitte jeweils den kompletten Youtube-Link in dieses Feld kopieren. Als z.B. <b><a
                href="https://www.youtube.com/watch?v=KNWccDbEqDU" target="_blank">https://www.youtube.com/watch?v=KNWccDbEqDU</a></b>.
        </div>
        <hr>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
  export default {
    props: ['project', 'blockData'],
    data () {
      return {
        block: this.blockData
      }
    },
    methods: {
      save () {
        let form = new FormData()
        if (this.block.showInNavigation) {
          form.append(
            'edit_film_block[showInNavigation]',
            this.block.showInNavigation
          )
        }
        form.append('edit_film_block[submit]', 1)

        Promise.all([
          this.$refs.name.save(),
          this.$refs.link.save(),
          this.$refs.text.save(),
          axios.post(
            '/api/' + store.state.language + '/block/' + this.block.id + '/edit',
            form
          )
        ]).then(() => {
        })
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/Blocks/FilmBlock.vue